import { productservices } from "../../services/productServices";
const initialstate = {
    'units': []
}

function getunits(){
   const token = localStorage.getItem('token'); // Retrieve your token
   if (token) {
        return productservices.getunits().then((response)=>{
            if(response.status == 200){
                return response.data.data;
            }    
        }).catch(()=>{
                return [];
        });
   }else{
      return [];
   }
}

const unitreducer = (state = initialstate,action) =>{
    switch(action.type) {
        case 'get':
              let data = getunits();       
              return {...state,units:data};
        default:
            let data1 = getunits();
           return state.units = data1;
           return state;   
    }
}

export default unitreducer;